import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { TheatersRounded, GraphicEqRounded } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import NewPackageInfoV3 from '@src/containers/Layout/SidebarNew/NewPackageInfoV3';
import ROUTES from '@src/constants/route';
import theme from '@src/styles/theme';
import NewActionsHeader from '@src/containers/Layout/NewActionsHeader';
import { NEW_ACTIONS_HEADER_MENU } from '@src/constants';
import actions from '@src/redux/actions';
import { useDispatch } from 'react-redux';
import { StyledTitleProduct } from './index.style';

const TitleProduct = () => {
  const { t } = useTranslation();
  const { pathname } = window.location;
  const dispatch = useDispatch();
  const history = useHistory();
  const ttsPaths = [ROUTES.TTS];
  const dubbingPaths = [ROUTES.HOME_DUBBING, ROUTES.DUBBING];

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const renderPackageInfo = () => <NewPackageInfoV3 />;
  const userPackageInfo = () =>
    !isMobile ? (
      <div className="wallet">
        <Box className="wallet-character">{renderPackageInfo()}</Box>
      </div>
    ) : (
      <></>
    );

  if (ttsPaths.includes(pathname)) {
    const renderTitle = () => t('newStudioName');
    return (
      <StyledTitleProduct isNewHeaderUI>
        <GraphicEqRounded className="icon" />
        <Typography className="lable-create-new">{renderTitle()}</Typography>
        {userPackageInfo()}
      </StyledTitleProduct>
    );
  }

  if (dubbingPaths.includes(pathname)) {
    const renderTitle = () => t('newDubbingName');
    return (
      <StyledTitleProduct>
        <TheatersRounded className="icon" />
        <Typography className="lable-create-new">{renderTitle()}</Typography>
        {!isMobile && (
          <NewActionsHeader
            menuShow={[
              NEW_ACTIONS_HEADER_MENU.TASK_CREDIT,
              NEW_ACTIONS_HEADER_MENU.GUIDE_CREDIT,
              NEW_ACTIONS_HEADER_MENU.NOTIFICATION,
              NEW_ACTIONS_HEADER_MENU.LEADERBOARD_VOICE,
            ]}
            onTaskCredits={() =>
              dispatch(actions.layout.setShowOnboardingPopup(true))
            }
            onLeaderboardVoice={() => {
              history.push(ROUTES.VOICE_LEADERBOARD);
            }}
          />
        )}
        {userPackageInfo()}
      </StyledTitleProduct>
    );
  }

  return <></>;
};
export default TitleProduct;
